module.exports = __webpack_public_path__ + "img/sky-clouds.35ee2998.png";